let getSettings = () => {
    return {
        // api : "http://localhost:3001",
        api : "https://shopnode123.herokuapp.com",
    }
}

export default getSettings()
